import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors, theme } from "../../theme/theme";
import { tagsData } from "../../assets/data";
import CustomDatePicker from "../Common/CustomDatePicker";
import CustomDropdown from "../Common/CustomDropdown";
import { CustomInput } from "../Common/CustomInput";
import { SearchOutlined } from "@mui/icons-material";

const ForumFilters = ({ date, setDate }) => {
  const [forumType, setForumType] = useState("");
  const [forumLocation, setforumLocation] = useState("");

  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={[theme.subHeading, { fontSize: "20px" }]}>
        Filters
      </Typography>

      <Box
        sx={{
          mt: 2,
        }}
      >
        <Typography sx={[theme.subHeading, { fontSize: "14px", mb: 0.5 }]}>
          CATEGORIES
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {tagsData.map((tag) => (
            <Box
              key={tag.id}
              sx={{
                border: `1px solid ${colors.secondary}`,
                borderRadius: "500px",
                px: 1,
                py: 0.5,
                fontSize: "12px",
                cursor: "pointer",
                color: colors.secondary,
                fontFamily: "Mulish-Medium",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: colors.secondary,
                  color: "white",
                },
              }}
            >
              {tag.name}
            </Box>
          ))}
        </Box>

        <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          DATE
        </Typography>
        <CustomDatePicker value={date} setValue={setDate} />

        {/* <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          FORUM TYPE
        </Typography>
        <CustomDropdown
          value={forumType}
          setValue={setForumType}
          data={[
            { label: "All", value: "all" },
            { label: "Popular", value: "popular" },
            { label: "Recent", value: "recent" },
          ]}
        /> */}

        {/* <Typography
          sx={[theme.subHeading, { fontSize: "14px", mt: 2, mb: 0.5 }]}
        >
          LOCATION
        </Typography>
        <CustomInput
          value={forumLocation}
          handleChange={(e) => setforumLocation(e.target.value)}
          rightIcon
          Icon={SearchOutlined}
          borderColor={"rgba(247,132,25,0.5)"}
          placeholder="Search location"
          type="text"
          bR={"9px"}
          height={"60px"}
          color={"#fff"}
          width={"100%"}
        /> */}
      </Box>
    </Box>
  );
};

export default ForumFilters;
